import React, { useState, useEffect } from "react";
import {
  Box,
  TextField,
  Typography,
  Button,
  IconButton,
  Radio,
  RadioGroup,
  FormControlLabel,
  InputAdornment,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { styled } from "@mui/material/styles";
import Drawer from "@mui/material/Drawer";
import contries from "../Roles and Permissions/Country.json";
import { api, post, put } from "../../../utils/api";
import SelectField from "../../../Components/Masters/SelectField";
import TaskAltIcon from "@mui/icons-material/TaskAlt";
import EmailField from "../../../Components/Masters/EmailField";
import PhoneField from "../../../Components/Masters/PhoneField";
import PhoneInput from "../../../Components/Masters/PhoneInput";
import { validateNumber } from "../../../utils/validateFields";
import InputField from "../../../Components/Masters/InputField";
import EditDialog from "../../../Components/Common/EditDialog";

function AddFacility(props) {
  const [alreadyFacility, setAlreadyFacility] = useState(false);
  const [errors, setErrors] = useState({});
  const initialState = {
    facilityName: "",
    address: "",
    nickname: "",
    incharge: "",
    outsourceFacility: "yes",
    country: "",
    countryCode: "",
    phone: "",
    email: "",
  };

  const [verifybtn, setverifybtn] = useState({ email: false, phone: false });
  const [verify, setVerify] = useState({
    phone: false,
    email: false,
    emailMsg: "",
    phoneMsg: "",
  });
  const [editDialog, setEditDialog] = useState(false);

  const [TaskAltIcons, setTaskAltIcons] = useState({
    email: false,
    phone: false,
  });

  const [fromValue, setFromValue] = useState(initialState);
  const [fromValue2, setFromValue2] = useState(initialState);

  const handleClose = () => {
    const isFormDataUnchanged = Object.keys(fromValue).every(
      (key) => fromValue[key] === fromValue2[key]
    );

    if (isFormDataUnchanged) {
      handleExitAgree();
    } else {
      setEditDialog(true);
    }
  };

  const handleExitAgree = () => {
    console.log("hiii")
    props.setAddFacility(false);
    setEditDialog(false);
    setverifybtn({ phone: false, email: false });
    setVerify({ phone: false, email: false, emailMsg: "", phoneMsg: "" });
    setTaskAltIcons({ phone: false, email: false });
    resetForm();
    // }
  };
  const resetForm = () => {
    console.log(" props.selectedFacility", props.selectedFacility);
    setFromValue(
      props.selectedFacility === null ? initialState : props.selectedFacility
    );
    setFromValue2(
      props.selectedFacility === null ? initialState : props.selectedFacility
    );
    setErrors({});
  };

  useEffect(() => {
    const state = {
      facilityName: props.selectedFacility?.facilityName ?? "",
      address: props.selectedFacility?.address ?? "",
      nickname: props.selectedFacility?.nickname ?? "",
      incharge: props.selectedFacility?.incharge ?? "",
      outsourceFacility: props.selectedFacility?.outsourceFacility ?? "yes",
      country: props.selectedFacility?.country ?? "",
      countryCode: props.selectedFacility?.countryCode ?? "",
      phone: props.selectedFacility?.phone ?? "",
      email: props.selectedFacility?.email ?? "",
    };
    setFromValue(state);
    setFromValue2(state);

    setTaskAltIcons({
      email: props?.selectedFacility?.email ? true : false,
      // phone: props?.selectedFacility?.phone ? true : false,
    });
    setAlreadyFacility(props.selectedFacility === null ? false : true);
  }, [props.selectedFacility]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    console.log("nam===e", name, value);
    setErrors((prev) => ({
      ...prev,
      [name]: "",
    }));
    setFromValue({
      ...fromValue,
      [name]: value,
    });
  };

  const handleCountryChange = (event) => {
    const selectedCountryCode = event.target.value;
    const selectedCountry = contries.countries.find(
      (country) => country.name === selectedCountryCode
    );

    if (selectedCountry) {
      setFromValue({
        ...fromValue,
        country: selectedCountry.name,
        countryCode: selectedCountry.dial_code,
        phone:""
      });

      setErrors((prev) => ({
        ...prev,
        country: "",
      }));

      if (selectedCountry.dial_code && fromValue.phone !== "") {
        setErrors({ ...errors, phone: "" });
      }
      if (errors.phone === "Please Select Country")
        setErrors({ ...errors, phone: "" });
    }
  };

  const validateForm = () => {
    const newErrors = {};

    const {
      facilityName,
      address,
      nickname,
      incharge,
      outsourceFacility,
      country,
      phone,
      email,
      countryCode,
    } = fromValue;

    // Validate `facilityName`
    if (!facilityName || facilityName.trim() === "") {
      newErrors.facilityName = "Facility name is required.";
    }

    // Validate `address`
    if (!address || address.trim() === "") {
      newErrors.address = "Address is required.";
    }

    // Validate `nickname`
    if (!nickname || nickname.trim() === "") {
      newErrors.nickname = "Nickname is required.";
    }

    // Validate `incharge`
    if (!incharge || incharge.trim() === "") {
      newErrors.incharge = "Incharge name is required.";
    }

    // Validate `outsourceFacility`
    if (
      !outsourceFacility ||
      (outsourceFacility !== "yes" && outsourceFacility !== "no")
    ) {
      newErrors.outsourceFacility =
        "Outsource facility must be either 'yes' or 'no'.";
    }

    // Validate `country`
    if (!country || country.trim() === "") {
      newErrors.country = "Country is required.";
    }

    const mobileNo = phone;
    if (mobileNo === "") newErrors.phone = `Mobile No. is required`;
    else if (countryCode === "")
      newErrors.countryCode = "Please Select Country";
    else if (!validateNumber(mobileNo) || mobileNo?.length < 7)
      newErrors.phone = "Please enter valid Mobile Number";
    // Set the error message for mobileNo
    // else if (errors.phone) return;
    // else if (verify.phone) {
    //   setVerify({
    //     ...verify,
    //     phoneMsg: verify.phoneMsg || "OTP is required",
    //   });
    //   newErrors["mblOtp"] = "OTP is required";
    // } else if (!TaskAltIcons.phone)
    //   newErrors["phone"] =
    //     errors.phone || "Contact Number Verification required"; // Set the error message for mobileNo

    if (email === "") newErrors["email"] = `Email is required`;
    // else if (errors.email) return;
    if (verify.email) {
      newErrors["emailOtp"] = "OTP is required";
      setVerify({
        ...verify,
        phoneMsg: verify.phoneMsg || "OTP is required",
        emailMsg: verify.emailMsg || "OTP is required",
      });
    } else if (email && !TaskAltIcons.email)
      newErrors[email] = "Email Verification required";

    setErrors(newErrors);
    console.log(newErrors, "err1");
    return Object.keys(newErrors).length === 0;
  };

  const Save = async () => {
    if (!validateForm()) {
      return;
    }

    try {
      const url = alreadyFacility
        ? `${api}/master/updateFacility?Id=${props.selectedFacility?._id}`
        : `${api}/master/addFacility`;

      const method = alreadyFacility ? put : post;
      const response = await method(url, { ...fromValue });

      resetForm();
      props.setAddFacility(false);
      props.setsnackOpen({
        open: true,
        message: response.data.message,
        severity: "success",
      });
      props.fetchFacilities();
    } catch (err) {
      props.setsnackOpen({
        open: true,
        message: err?.response?.data?.message || "An error occurred",
        severity: "error",
      });
    }
  };

  const handlePhoneChange = (e) => {
    const { name, value } = e.target;
    if (fromValue?.countryCode === "") {
      setErrors({ ...errors, phone: "Please Select Country" });
      return;
    }
    setErrors({ ...errors, phone: "" });
    const phoneNumberPattern = /^[0-9]*$/;
    if (phoneNumberPattern.test(value) && value.length <= 10) {
      setFromValue({
        ...fromValue,
        [name]: value,
      });
    } else {
      console.log("error");
      // setErrors({ ...errors, phone: "Invalid Phone Number" });
    }
  };

  const list = () => (
    <Box
      display="flex"
      gap={3}
      sx={{
        width: "27rem",
        // maxWidth:"100%",
        height: "100vh",
        display: "flex",
        justifyContent: "space-btween",
        backgroundColor: "transparent",
      }}
    >
      {editDialog && (
        <EditDialog {...{ editDialog, setEditDialog, handleExitAgree }} />
      )}
      <Box
        sx={{
          backgroundColor: "#fff",
          height: "3%",
          padding: "13px",
          margin: "30px 0 0 0",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          borderRadius: "80%",
          width: "5%",
        }}
      >
        <IconButton
          onClick={handleClose}
          sx={{ color: "black" }}
        >
          <CloseIcon sx={{ fontSize: "1.2rem" }} />
        </IconButton>
      </Box>
      <Box
        sx={{
          padding: "24px",
          backgroundColor: "#fff",
          height: "100%",
          width: "100%",
          overflowY: "scroll",
        }}
      >
        <Typography
          variant="h6"
          sx={{
            textDecoration: "underline",
            fontWeight: "bold",

            mb: 2,
          }}
        >
          {props.selectedFacility?._id === undefined
            ? "Add Facility"
            : "Edit Facility"}
        </Typography>

        <Typography variant="subtitle1" sx={{ fontWeight: "bold", mt: 1 }}>
          Name of Facility
        </Typography>

        <CustomTextField
          //   select
          variant="outlined"
          value={fromValue.facilityName}
          onChange={handleChange}
          fullWidth
          name="facilityName"
          placeholder="Enter Name"
          error={!!errors.facilityName} // Show error styling if there's an error
          InputLabelProps={{
            style: { color: errors.facilityName ? "#D34040" : undefined },
          }}
        ></CustomTextField>
        {errors.facilityName && (
          <Typography variant="body2" color="#D34040">
            {errors.facilityName}
          </Typography>
        )}

        <Typography variant="subtitle1" sx={{ fontWeight: "bold", mt: 1 }}>
          Nickname
        </Typography>

        <CustomTextField
          variant="outlined"
          value={fromValue.nickname}
          onChange={handleChange}
          fullWidth
          name="nickname"
          placeholder="Nickname"
          error={!!errors.nickname}
          InputLabelProps={{
            style: { color: errors.nickname ? "#D34040" : undefined },
          }}
        ></CustomTextField>
        {errors.nickname && (
          <Typography variant="body2" color="#D34040">
            {errors.nickname}
          </Typography>
        )}

        <Typography variant="subtitle1" sx={{ fontWeight: "bold", mt: 1 }}>
          Address
        </Typography>
        <CustomTextField
          //  select
          variant="outlined"
          value={fromValue.address}
          onChange={handleChange}
          fullWidth
          name="address"
          placeholder="Address"
          error={!!errors.address}
          InputLabelProps={{
            style: { color: errors.address ? "#D34040" : undefined },
          }}
        ></CustomTextField>
        {errors.address && (
          <Typography variant="body2" color="#D34040">
            {errors.address}
          </Typography>
        )}
        <SelectField
          title={"Country"}
          name={"country"}
          value={fromValue.country}
          handleChange={handleCountryChange}
          options={contries.countries}
          errors={errors["country"]}
        />
        <Typography variant="subtitle1" sx={{ fontWeight: "bold", mt: 1 }}>
          Mobile No.
        </Typography>
        <Box
          sx={{
            display: `${TaskAltIcons.phone === true ? "flex" : "block"}`,
            width: `${TaskAltIcons.phone === true ? "100%" : "100%"}`,
          }}
        >
          <CustomTextField
            variant="outlined"
            value={fromValue.phone}
            onChange={handlePhoneChange}
            fullWidth
            name="phone"
            placeholder="Enter Mobile No."
            InputProps={{
              maxLength: 10, // Visual limit
              inputMode: "numeric",
              pattern: "[0-9]*",
              // endAdornment: showIcon && <TaskAltIcon sx={{ color: "green" }} />,
              startAdornment: (
                <InputAdornment
                  position="start"
                  sx={{ display: "flex", alignItems: "center" }}
                >
                  {/* Render placeholder or countryCode */}
                  {fromValue?.countryCode ? (
                    <div
                      style={{
                        width: "40px",
                        marginRight: "8px",
                        fontWeight: "bold",
                      }}
                    >
                      {fromValue?.countryCode}
                    </div>
                  ) : (
                    <div
                      style={{
                        width: "40px",
                        marginRight: "8px",
                        color: "#B0B0B0",
                      }}
                    >
                      {"code"}
                    </div>
                  )}
                  {/* Vertical Line */}
                  <div
                    style={{
                      borderRight: "1px solid #000",
                      height: "24px",
                      marginRight: "8px",
                    }}
                  />
                </InputAdornment>
              ),
            }}
          />
        </Box>
        {errors.phone && (
          <Typography variant="body2" color="#D34040">
            {errors.phone}
          </Typography>
        )}

        {/* <PhoneInput
          value={fromValue?.phone || ""} // Use optional chaining
          errors={errors["phone"]}
          fieldName={"phone"}
          placeholder="Enter Mobile Number"
          title="Mobile No."
          showIcon={TaskAltIcons.phone === true}
          {...{
            setTaskAltIcons,
            TaskAltIcons,
            setErrors,
            setFormData: setFromValue,
            element: props?.selectedFacility,
            formData: fromValue,
            setVerify,
            verify,
            setverifybtn,
            verifybtn,
          }}
          countryCode={fromValue?.countryCode || ""} // Use optional chaining
        /> */}

        {/* <InputField/> */}

        <EmailField
          title={"Email ID"}
          // handleChange={handleEmailChange}
          placeholder="Enter Email"
          value={fromValue?.email || ""}
          errors={errors["email"]}
          fieldName={"email"}
          showIcon={TaskAltIcons.email === true}
          {...{
            setTaskAltIcons,
            TaskAltIcons,
            setErrors,
            setFormData: setFromValue,
            element: props?.selectedFacility,
            formData: fromValue,
            setVerify,
            verify,
            setverifybtn,
            verifybtn,
          }}
        />

        <Typography variant="subtitle1" sx={{ fontWeight: "bold", mt: 1 }}>
          Person Incharge
        </Typography>
        <CustomTextField
          //  select
          variant="outlined"
          value={fromValue.incharge}
          onChange={handleChange}
          fullWidth
          name="incharge"
          placeholder="Person Incharge"
          error={!!errors.incharge}
          InputLabelProps={{
            style: { color: errors.incharge ? "#D34040" : undefined },
          }}
        ></CustomTextField>
        {errors.incharge && (
          <Typography variant="body2" color="#D34040">
            {errors.incharge}
          </Typography>
        )}
        <Typography variant="subtitle1" sx={{ fontWeight: "bold", mt: 1 }}>
          Outsource Facility
        </Typography>

        <RadioGroup
          row
          value={fromValue.outsourceFacility}
          name="outsourceFacility"
          onChange={handleChange}
        >
          <FormControlLabel value="yes" control={<Radio />} label="Yes" />
          <FormControlLabel value="no" control={<Radio />} label="No" />
        </RadioGroup>

        {/* <Box> */}
        <Button
          variant="contained"
          sx={{
            backgroundColor: "#0a3f73",
            textTransform: "none",
            marginTop: "10%",
          }}
          onClick={Save}
        >
          Submit
        </Button>
        {/* </Box> */}
      </Box>
    </Box>
  );

  return (
    <div>
      <Drawer
        sx={{
          backgroundColor: "transparent",
          "& .MuiDrawer-paper": {
            backgroundColor: "transparent",
            boxShadow: "none",
          },
        }}
        anchor="right"
        open={props.addFacility}
        onClose={handleClose}
      >
        {list()}
      </Drawer>
    </div>
  );
}

export default AddFacility;

const CustomTextField = styled(TextField)(({ theme }) => ({
  "& .MuiInputBase-root": {
    height: "40px", // Adjust height as needed
  },
  "& .MuiSelect-select": {
    height: "56px", // Adjust height as needed
    display: "flex",
    alignItems: "center",
  },
}));
